export default "__VITE_PUBLIC_ASSET__1d209290__"